import { RovoAgentSkeleton } from '@jira/platform__skeletons/src/ui/getting-started-page/RovoAgentSkeleton.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRoute } from '@jira/router-routes__servicedesk-getting-started-page-routes/src/servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { gettingStartedRovoServiceAgentSelfServiceSetupEntryPoint } from '@jira/spa-apps__servicedesk-getting-started-page/src/gettingStartedRovoServiceAgentSelfServiceSetupEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const rovoAgentSelfServiceSetupPageEntryPoint = createPageEntryPoint({
	main: gettingStartedRovoServiceAgentSelfServiceSetupEntryPoint,
});

export const servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRouteEntry: Route =
	createEntry(servicedeskGettingStartedRovoServiceAgentSelfServiceSetupRoute, () => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-getting-started-rovo-self-service-setup-load',
		skeleton: RovoAgentSkeleton,
		entryPoint: () =>
			fg('solution_composer_master') ? rovoAgentSelfServiceSetupPageEntryPoint : undefined,
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		navigation: {
			menuId: MenuIdProjects,
		},
		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
